/* PRODUCT ZOOM */
var main_productVisu = null;
var zoomProduct = null;
var zoomThumbs = null;

function zoomImg(slide) {

    $('#zoom_box_wrapper').css('opacity', 0);

    // Disable the Swipers of the main page to avoid conflicts
    if (main_productVisu && typeof main_productVisu.disable === 'function') {
        main_productVisu.disable();
    }
    var visualScrollerEl = document.querySelector('#visual_scroller');
    if (visualScrollerEl && visualScrollerEl.swiper && typeof visualScrollerEl.swiper.disable === 'function') {
        visualScrollerEl.swiper.disable();
    }
    var jqzoomEl = document.querySelector('#jqzoom');
    if (jqzoomEl && jqzoomEl.swiper && typeof jqzoomEl.swiper.disable === 'function') {
        jqzoomEl.swiper.disable();
    }

    window.setTimeout(function () {
        /* Init zoom thumbs swiper */
        if ($("#thumbs_scroller .swiper-slide").length > 1) {
            if (!$("#thumbs_scroller.swiper-initialized").length) {
                zoomThumbs = new Swiper('#thumbs_scroller', {
                    slidesPerView: 'auto',
                    spaceBetween: 24,
                    direction: "vertical",
                    loop: false,
                    freeMode: true,
                    watchSlidesProgress: true,
                    navigation: {
                        nextEl: '.zoomThumbsNext',
                        prevEl: '.zoomThumbsPrev',
                    },
                    threshold: 4,
                });
            }
        } else {
            $("#thumbs_scroller, .thumbs_wrapper").addClass('no_swiper')
        }

        /* Init zoom main swiper */
        if ($("#zoom_box_wrapper .swiper-slide").length > 1) {
            if (!$("#zoom_box_wrapper.swiper-initialized").length) {
                var zoomConfig = {
                    slidesPerView: 1,
                    mousewheel: false,
                    loop: false,
                    zoom: {
                        maxRatio: 3,
                        minRatio: 1,
                        toggle: true,
                    },
                    navigation: {
                        nextEl: ".zoomProdNext",
                        prevEl: ".zoomProdPrev",
                    },
                };
                
                if (typeof zoomThumbs !== 'undefined' && zoomThumbs) {
                    zoomConfig.thumbs = {
                        swiper: zoomThumbs
                    };
                }

                zoomProduct = new Swiper('.productLightboxVisu', zoomConfig);
            }
        } else {
            $("#zoom_box_wrapper").addClass('no_swiper')
        }

        if (typeof zoomProduct !== 'undefined' && zoomProduct) {
            if (slide == null) {
                if (typeof(productMainVisu) != 'undefined') {
                    zoomProduct.slideTo(productMainVisu.activeIndex);
                }
            } else {
                if ($('#thumbs_scroller .video_holder').length > 0) {
                    zoomProduct.slideTo(slide);
                } else {
                    zoomProduct.slideTo(slide - 1);
                }
            }

            zoomProduct.on('slideChange',() => {
                if (zoomProduct.zoom && zoomProduct.zoom.enabled && zoomProduct.zoom.scale > 1) {
                    zoomProduct.zoom.out();
                }
                main_productVisu.slideTo(zoomProduct.activeIndex);
            });
        }

    }, 50);

    window.setTimeout(function () {
        $('#zoom_box_wrapper').css('opacity', 1);
    }, 350);

    openMultiShad('zoomBox');
    $("#shad_abox").addClass('actif white');

    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    $('body.product_page').css({
        'position': 'fixed',
        'width': '100%',
        'padding-right': scrollbarWidth + 'px'
    });
}


$(function () {
    $('#shad_abox').on("click", function() {
        closeMultiShad();
        $('.lightbox.actif').removeClass('actif');

        $('body.product_page').css({
            'position': '',
            'width': '',
            'padding-right': ''
        });

        // Reactivate the Swipers of the main page
        if (typeof main_productVisu !== 'undefined' && main_productVisu && typeof main_productVisu.enable === 'function') {
            main_productVisu.enable();
        }
        var visualScrollerEl = document.querySelector('#visual_scroller');
        if (visualScrollerEl && visualScrollerEl.swiper && typeof visualScrollerEl.swiper.enable === 'function') {
            visualScrollerEl.swiper.enable();
        }
        var jqzoomEl = document.querySelector('#jqzoom');
        if (jqzoomEl && jqzoomEl.swiper && typeof jqzoomEl.swiper.enable === 'function') {
            jqzoomEl.swiper.enable();
        }
    });


    if ($("#jqzoom .swiper-slide").length > 1) {

        //animation to avoid slide's width transition on pageload
        $('#jqzoom, #visual_scroller_wrapper').animate({
            opacity: 1,
        },10);

        main_productVisu = $("#jqzoom");
        var productThumbs = $("#visual_scroller");

        // PRODUCT SWIPER
        if ($("#visual_scroller .swiper-slide").length > 1) {
            productThumbs = new Swiper('#visual_scroller', {
                slidesPerView: 4,
                spaceBetween: 36,
                direction: 'vertical',
                loop: false,
                navigation: {
                    nextEl: '#visual_scroller_wrapper .thumbNext',
                    prevEl: '#visual_scroller_wrapper .thumbPrev',
                },
                breakpoints: {
                    640: {
                        slidesPerView: 1.25,
                        spaceBetween: 10,
                        centeredSlides: true,
                    },
                    1160: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1420: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                        centeredSlides: false,
                    },
                    1680: {
                        slidesPerView: 4,
                        spaceBetween: 36,
                        centeredSlides: false,
                    },
                }
            });

        } else {
            $("#visual_scroller_wrapper").addClass('no_swiper');
        }

        main_productVisu = new Swiper('#jqzoom', {
            loadOnTransitionStart: true,
            rewind: true,
            thumbs: {
                swiper: productThumbs
            },
            pagination: {
                el: '#jqzoom .swiper-pagination',
                type: "progressbar"
            },
            navigation: {
                nextEl: "#jqzoom ~ .swiper-button-next",
                prevEl: "#jqzoom ~ .swiper-button-prev",
            },
            slidesPerView: 1,
            loop: false,
        });

        main_productVisu.on('slideChange',() => {
            productThumbs.slideTo(main_productVisu.activeIndex);
        });

        if ($('#jqzoom .swiper-slide').hasClass('has_video')) {
            $('#jqzoom + .swiper-pagination').addClass('outarea');
            $('.product_page .page_produit .wrapper_product_detail').css('padding','25px');
        }
    }

    if ($("body").hasClass("product_page")) {
        resetThumbSwiperFP();

        $(window).on('resize', function () {
            resetThumbSwiperFP();
        });
    }

    // Initialization of OverlayScrollbars for dimension_carac
    if ($('#dimension_carac').length) {
        window.setTimeout(function() {
            $('#dimension_carac .wrapping').overlayScrollbars({});
        }, 1000);
    }

    // Bundle caracs (desktop): accordion with single opened item
    if ($('body.product_page').length && $('.bundle_caracs').length) {
        $('.bundle_caracs').on('click', '.title_container_bundle', function (e) {
            e.preventDefault();

            var $title = $(this);
            var $arrow = $title.find('.caracPanel_arrow').first();
            var $productRow = $title.closest('.bundle_caracs_product');
            var $container = $productRow.find('.bundle_caracs_container').first();

            if ($container.length === 0) return;

            var isOpen = $container.hasClass('collapsible_opened');

            // Close other opened containers
            $('.bundle_caracs .bundle_caracs_container.collapsible_opened').not($container).each(function () {
                var $other = $(this);
                var $otherRow = $other.closest('.bundle_caracs_product');
                $otherRow.find('.title_container_bundle .caracPanel_arrow').removeClass('opened');
                $other.stop(true, true).slideUp(200, function () {
                    $other.removeClass('collapsible_opened');
                });
            });

            // Toggle current
            if (isOpen) {
                $container.stop(true, true).slideUp(200, function () {
                    $container.removeClass('collapsible_opened');
                });
                $arrow.removeClass('opened');
            } else {
                $container.addClass('collapsible_opened').stop(true, true).slideDown(200);
                $arrow.addClass('opened');
            }
        });
    }

    // Initialization of the sticky block for the product page
    if ($('.product_page').length) {
        product_sticky_block(true);

        // Initialization of Swiper for the sizes
        function initSizesSwiper() {
            var $sizesContainer = $('.size_list.swiper-container');
            if ($sizesContainer.length && $sizesContainer.find('.swiper-slide').length >= 3) {
                var $wrapper = $sizesContainer.find('.swiper-wrapper');
                var $checked = $wrapper.children('.swiper-slide.checked');
                if ($checked.length) {
                    $wrapper.prepend($checked);
                }

                if ($sizesContainer[0].swiper) {
                    $sizesContainer[0].swiper.destroy(true, true);
                }

                var sizesSwiper = new Swiper('.size_list.swiper-container', {
                    slidesPerView: 'auto',
                    freeMode: true,
                    navigation: {
                        nextEl: '.choices_list_next',
                        prevEl: '.choices_list_prev',
                    },
                    on: {
                        init: function() {
                            // Remove the cache class once the swiper is initialized
                            var $container = $(this.el).closest('.list_container');
                            $container.find('.choices_list_prev, .choices_list_next').removeClass('cache');
                        }
                    }
                });
            }
        }

        initSizesSwiper();

        $(document).on('itmAddedToCart itmColorChanged itmProductReloaded', function() {
            setTimeout(initSizesSwiper, 100);
        });

        // Add smooth scroll to netreviews reviews on product page
        $(document).on('click', '#netreviews_container .total_reviews', function(event) {
            event.preventDefault();

            if ($('#w-netreviews-comments').length) {

                $('html, body').animate({
                    scrollTop: $('#w-netreviews-comments').offset().top - (15 * $(window).height() / 100)
                }, 600);
            }
        });

        const productSelects = document.querySelector('#product_selects');

        if (productSelects) {
            const colorInputs = productSelects.querySelectorAll('input.prodColor');

            if (colorInputs.length === 1) {
                const uniqueColor = colorInputs[0];

                if (!uniqueColor.checked) {
                    uniqueColor.checked = true;
                    uniqueColor.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        }
    }
});


/* DESCRIPTION */

$(document).ready(function(){
    $('.thumbslide .see_more').on('click', function(e) {
        $('.thumbslide').removeClass('active');
        $(this).parents('.thumbslide').addClass('active');
    });

    // START PANEL TABS JS

    // ============================================================================
    // CONSTANTS
    // ============================================================================
    var TAB_CONFIG = {
        ANIMATION_DURATION: 300,
        SCROLL_OFFSET: 180,
        SCROLL_DURATION: 500,
        ELEMENT_WAIT_TIMEOUT: 10000,
        SELECTORS: {
            TABS_CONTAINER: '.product_tabs',
            TAB_BUTTON: '.product_tabs .tab_button',
            TITLE_CONTAINER: '.product_tabs .title_container',
            PANEL: '.panel',
            PANEL_CONTENT: '.panel_content',
        },
        CLASSES: {
            ACTIVE: 'active',
            OPENED: 'opened',
            IS_OPENED: 'isOpened'
        },
        LEGACY_MAPPING: {
            'carac_du_lot': 'item_carac_du_lot'
        }
    };

    // ============================================================================
    // UTILITY FUNCTIONS
    // ============================================================================

    /**
     * Normalizes tab ID by applying legacy mapping if needed
     * @param {string} tabId - The tab ID to normalize
     * @returns {string} - The normalized tab ID
     */
    function normalizeTabId(tabId) {
        if (!tabId) return tabId;
        return TAB_CONFIG.LEGACY_MAPPING[tabId] || tabId;
    }

    /**
     * Finds the content container within a panel (supports 3 types)
     * @param {jQuery} $panel - The panel jQuery object
     * @returns {jQuery} - The content container jQuery object
     */
    function getContentToToggle($panel) {
        var $content = $panel.find(TAB_CONFIG.SELECTORS.PANEL_CONTENT);
        return $content;
    }

    /**
     * Gets the title container for a given tab ID
     * @param {string} tabId - The normalized tab ID
     * @returns {jQuery} - The title container jQuery object
     */
    function getTitleContainerByTabId(tabId) {
        var normalizedId = normalizeTabId(tabId);
        return $(TAB_CONFIG.SELECTORS.TABS_CONTAINER + ' [data-tab="' + normalizedId + '"]');
    }

    /**
     * Gets the tab button for a given tab ID
     * @param {string} tabId - The tab ID (not normalized, as buttons use original IDs)
     * @returns {jQuery} - The tab button jQuery object
     */
    function getTabButtonByTabId(tabId) {
        return $(TAB_CONFIG.SELECTORS.TAB_BUTTON + '[data-open="' + tabId + '"]');
    }

    /**
     * Removes active class from all tab buttons
     */
    function deactivateAllButtons() {
        $(TAB_CONFIG.SELECTORS.TAB_BUTTON).removeClass(TAB_CONFIG.CLASSES.ACTIVE);
    }

    /**
     * Activates a tab button by tab ID
     * @param {string} tabId - The tab ID
     */
    function activateButton(tabId) {
        if (tabId) {
            getTabButtonByTabId(tabId).addClass(TAB_CONFIG.CLASSES.ACTIVE);
        }
    }

    /**
     * Deactivates a tab button by tab ID
     * @param {string} tabId - The tab ID
     */
    function deactivateButton(tabId) {
        if (tabId) {
            getTabButtonByTabId(tabId).removeClass(TAB_CONFIG.CLASSES.ACTIVE);
        }
    }

    // ============================================================================
    // ANIMATION FUNCTIONS
    // ============================================================================

    /**
     * Closes a content container with appropriate animation
     * @param {jQuery} $content - The content container to close
     * @param {Function} callback - Optional callback after animation completes
     */
    function closeContent($content, callback) {
        if ($content.length === 0) {
            if (callback) callback();
            return;
        }

        $content.slideUp(TAB_CONFIG.ANIMATION_DURATION, function() {
            $content.removeClass(TAB_CONFIG.CLASSES.IS_OPENED);
            if (callback) callback();
        });
    }

    /**
     * Opens a content container with appropriate animation
     * @param {jQuery} $content - The content container to open
     * @param {boolean} useAnimation - Whether to use slideDown animation (default: true)
     * @param {Function} callback - Optional callback after animation completes
     */
    function openContent($content, useAnimation, callback) {
        if ($content.length === 0) {
            if (callback) callback();
            return;
        }

        useAnimation = useAnimation !== false; // Default to true

        $content.addClass(TAB_CONFIG.CLASSES.IS_OPENED);
        if (useAnimation) {
            $content.slideDown(TAB_CONFIG.ANIMATION_DURATION, callback);
        } else {
            $content.show();
            if (callback) callback();
        }
    }

    /**
     * Scrolls to a target element with offset
     * @param {jQuery} $target - The target element to scroll to
     * @param {Function} callback - Optional callback after scroll completes
     */
    function scrollToElement($target, callback) {
        if ($target.length === 0) {
            if (callback) callback();
            return;
        }

        var targetPosition = $target.offset().top - TAB_CONFIG.SCROLL_OFFSET;
        targetPosition = Math.max(0, targetPosition);

        $('html, body').animate({
            scrollTop: targetPosition
        }, TAB_CONFIG.SCROLL_DURATION, callback);
    }

    /**
     * Waits for DOM to stabilize using double requestAnimationFrame
     * @param {Function} callback - Function to execute after DOM stabilization
     */
    function waitForDOMStabilization(callback) {
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (callback) callback();
            });
        });
    }

    // ============================================================================
    // TAB MANAGEMENT FUNCTIONS
    // ============================================================================

    /**
     * Closes all opened tabs with callback support
     * @param {Function} callback - Function to execute after all tabs are closed
     */
    function closeAllTabs(callback) {
        var $openedTabs = $(TAB_CONFIG.SELECTORS.TITLE_CONTAINER + '.' + TAB_CONFIG.CLASSES.OPENED);

        if ($openedTabs.length === 0) {
            deactivateAllButtons();
            if (callback) callback();
            return;
        }

        var closedCount = 0;
        var totalToClose = $openedTabs.length;

        $openedTabs.each(function() {
            var $titleContainer = $(this);
            var $panel = $titleContainer.closest(TAB_CONFIG.SELECTORS.PANEL);
            var $content = getContentToToggle($panel);

            $titleContainer.removeClass(TAB_CONFIG.CLASSES.OPENED);

            closeContent($content, function() {
                closedCount++;
                if (closedCount === totalToClose) {
                    deactivateAllButtons();
                    if (callback) callback();
                }
            });
        });
    }

    /**
     * Opens a tab by its button
     * @param {jQuery} $tabButton - The tab button jQuery object
     * @param {boolean} useAnimation - Whether to use animation (default: false for init)
     */
    function openTabByButton($tabButton, useAnimation) {
        if ($tabButton.length === 0) return;

        var targetTab = normalizeTabId($tabButton.attr('data-open'));
        var $titleContainer = getTitleContainerByTabId(targetTab);

        if ($titleContainer.length === 0) return;

        var $panel = $titleContainer.closest(TAB_CONFIG.SELECTORS.PANEL);
        var $content = getContentToToggle($panel);

        if ($content.length > 0 && !$titleContainer.hasClass(TAB_CONFIG.CLASSES.OPENED)) {
            $titleContainer.addClass(TAB_CONFIG.CLASSES.OPENED);
            openContent($content, useAnimation);
        }
    }

    /**
     * Opens a new tab with scroll handling
     * @param {jQuery} $clickedButton - The clicked button
     * @param {string} targetTab - The target tab ID (already normalized)
     */
    function openNewTab($clickedButton, targetTab) {
        $clickedButton.addClass(TAB_CONFIG.CLASSES.ACTIVE);

        var $titleContainer = getTitleContainerByTabId(targetTab);
        if ($titleContainer.length === 0) return;

        var $panel = $titleContainer.closest(TAB_CONFIG.SELECTORS.PANEL);
        var $content = getContentToToggle($panel);

        waitForDOMStabilization(function() {
            if ($content.length > 0) {
                $titleContainer.addClass(TAB_CONFIG.CLASSES.OPENED);

                // Ouvrir le contenu avec animation et scroller après l'ouverture
                $content.addClass(TAB_CONFIG.CLASSES.IS_OPENED);
                $content.slideDown(TAB_CONFIG.ANIMATION_DURATION, function() {
                    scrollToContent($content);
                });
            }
        });
    }

    /**
     * Scrolls to content after opening
     * @param {jQuery} $content - The content container to scroll to
     */
    function scrollToContent($content) {
        if ($content.length === 0) return;

        // Wait a little for the DOM to be completely stabilized after the animation
        setTimeout(function() {
            scrollToElement($content, function() {
            });
        }, 50);
    }

    /**
     * Handles tab opening from title container click
     * @param {jQuery} $titleContainer - The clicked title container
     * @param {string} targetTab - The target tab ID
     */
    function openTabByTitle($titleContainer, targetTab) {
        var $panel = $titleContainer.closest(TAB_CONFIG.SELECTORS.PANEL);
        var $content = getContentToToggle($panel);

        activateButton(targetTab);
        $titleContainer.addClass(TAB_CONFIG.CLASSES.OPENED);

        // Open the content and scroll after opening
        openContent($content, true, function() {
            // Wait a little for the DOM to be stabilized after the animation
            setTimeout(function() {
                scrollToElement($content);
            }, 50);
        });
    }

    /**
     * Handles tab closing from title container click
     * @param {jQuery} $titleContainer - The clicked title container
     * @param {string} targetTab - The target tab ID
     */
    function closeTabByTitle($titleContainer, targetTab) {
        var $panel = $titleContainer.closest(TAB_CONFIG.SELECTORS.PANEL);
        var $content = getContentToToggle($panel);

        $titleContainer.removeClass(TAB_CONFIG.CLASSES.OPENED);
        closeContent($content);
        deactivateButton(targetTab);
    }

    // ============================================================================
    // INITIALIZATION FUNCTIONS
    // ============================================================================

    /**
     * Hides all tabs by default, except those marked as opened
     */
    function hideAllTabs() {
        $(TAB_CONFIG.SELECTORS.TABS_CONTAINER + ' ' + TAB_CONFIG.SELECTORS.PANEL_CONTENT).each(function() {
            var $content = $(this);
            var $panel = $content.closest(TAB_CONFIG.SELECTORS.PANEL);
            var $titleContainer = $panel.find(TAB_CONFIG.SELECTORS.TITLE_CONTAINER).first();

            if ($titleContainer.hasClass(TAB_CONFIG.CLASSES.OPENED)) {
                $content.addClass(TAB_CONFIG.CLASSES.IS_OPENED).show();
            } else {
                $content.removeClass(TAB_CONFIG.CLASSES.IS_OPENED).hide();
            }
        });
    }

    /**
     * Initializes product tabs: opens the first active tab or the first available tab
     */
    function initProductTabs() {
        if ($(TAB_CONFIG.SELECTORS.TABS_CONTAINER).length === 0) {
            return;
        }

        var $activeTabButton = $(TAB_CONFIG.SELECTORS.TAB_BUTTON + '.' + TAB_CONFIG.CLASSES.ACTIVE).first();
        var $firstTabButton = $(TAB_CONFIG.SELECTORS.TAB_BUTTON).first();

        if ($activeTabButton.length > 0) {
            openTabByButton($activeTabButton, false);
        } else if ($firstTabButton.length > 0) {
            $firstTabButton.addClass(TAB_CONFIG.CLASSES.ACTIVE);
            openTabByButton($firstTabButton, false);
        }
    }

    /**
     * Waits for elements to appear in the DOM using MutationObserver
     * @param {string} selector - CSS selector to wait for
     * @param {Function} callback - Function to execute when elements are found
     * @param {number} timeout - Maximum wait time in milliseconds
     */
    function waitForElements(selector, callback, timeout) {
        timeout = timeout || TAB_CONFIG.ELEMENT_WAIT_TIMEOUT;
        var startTime = Date.now();
        var elementsFound = false;

        // Check immediately if elements exist
        if ($(selector).length > 0) {
            elementsFound = true;
            if (callback) callback();
            return;
        }

        // Create MutationObserver to watch for DOM changes
        var observer = new MutationObserver(function(mutations) {
            if ($(selector).length > 0 && !elementsFound) {
                elementsFound = true;
                observer.disconnect();
                if (callback) callback();
            }

            if (Date.now() - startTime > timeout) {
                observer.disconnect();
                if (callback) callback();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Set a safety timeout
        setTimeout(function() {
            if (!elementsFound) {
                observer.disconnect();
                if (callback) callback();
            }
        }, timeout);
    }

    // ============================================================================
    // EVENT HANDLERS
    // ============================================================================

    /**
     * Handles tab button click
     */
    $(document).on('click', TAB_CONFIG.SELECTORS.TAB_BUTTON, function(e) {
        e.preventDefault();

        var $clickedButton = $(this);
        var targetTab = normalizeTabId($clickedButton.attr('data-open'));

        // Close all tabs, then open new tab (which will scroll to content)
        closeAllTabs(function() {
            openNewTab($clickedButton, targetTab);
        });
    });

    /**
     * Handles title container click
     */
    $(document).on('click', TAB_CONFIG.SELECTORS.TITLE_CONTAINER, function(e) {
        e.preventDefault();

        var $titleContainer = $(this);
        var $panel = $titleContainer.closest(TAB_CONFIG.SELECTORS.PANEL);
        var $content = getContentToToggle($panel);
        var isOpened = $titleContainer.hasClass(TAB_CONFIG.CLASSES.OPENED);
        var targetTab = $titleContainer.attr('data-tab');

        if (isOpened) {
            // Close the tab
            closeTabByTitle($titleContainer, targetTab);
        } else {
            // Close all tabs, then open this one
            closeAllTabs(function() {
                openTabByTitle($titleContainer, targetTab);
            });
        }
    });

    // ============================================================================
    // INITIALIZATION
    // ============================================================================

    // Expose reinitProductTabs globally so it can be called after DOM updates (e.g. color/size change)
    // Must hide all tabs first, then open the first one — same as initial loading
    window.reinitProductTabs = function() {
        hideAllTabs();
        initProductTabs();
    };

    // Initialize product tabs when elements are ready
    waitForElements(TAB_CONFIG.SELECTORS.TAB_BUTTON, function() {
        hideAllTabs();
        initProductTabs();
    }, TAB_CONFIG.ELEMENT_WAIT_TIMEOUT);


    // FP only: init cross-sell carousels (other pages handled by the global init at the bottom of this file).
    if ($('body').hasClass('product_page') && $('.cross-sell-carousel').length) {
        initFpCrossSell();
    }
});

// END PANEL TABS JS

function resetThumbSwiperFP() {
    var swiper_FP_main_push_height = $("#jqzoom").height();
    var swiper_FP_main_push_width = $("#jqzoom").width();
    $("#jqzoom").height(swiper_FP_main_push_width);
    $("#visual_scroller_wrapper").height(swiper_FP_main_push_width - (2*60));
    $("#visual_scroller_wrapper").addClass('is-active');

}

function product_sticky_block(isInit = false) {
    setTimeout(function () {
        const addCartEl = document.querySelector('#product_addcart');

        // site_head_wrap real height components
        const preHeaderWrapper = $(".pre_header_wrapper");
        var preHeaderWrapperHeight = preHeaderWrapper.length ? preHeaderWrapper.height() : 0;

        const topWrapper = $("#top_wrapper");
        var topWrapperHeight = topWrapper.length ? topWrapper.height() : 0;

        const mainMenuWrapper = $(".main_menu_wrapper");
        var mainMenuWrapperHeight = mainMenuWrapper.length ? mainMenuWrapper.height() : 0;

        var headerHeight = preHeaderWrapperHeight + topWrapperHeight + mainMenuWrapperHeight;

        // target elements
        const targetDiv = $(".product_info");

        // #product_addcart lives inside .product_info, and "scrolling-active" repositions it into the
        // fixed sticky bar. Measuring its live rect after toggling the class would flip-flop endlessly,
        // so the trigger is cached as an absolute scroll position instead, refreshed only while not sticky.
        var triggerScrollY = null;

        function computeTriggerScrollY() {
            if (!addCartEl || targetDiv.hasClass("scrolling-active")) return;
            triggerScrollY = addCartEl.getBoundingClientRect().bottom + window.scrollY - headerHeight;
        }

        function handle_sticky_block() {
            if (!addCartEl) return;

            if (triggerScrollY === null) {
                computeTriggerScrollY();
            }
            if (triggerScrollY === null) return;

            // Sticky once the add-to-cart CTA has scrolled below (out of view above the header)
            const shouldBeSticky = window.scrollY >= triggerScrollY;

            if (shouldBeSticky) {
                if (!targetDiv.hasClass("scrolling-active")) {
                    targetDiv.addClass("scrolling-active");
                    document.body.style.paddingBottom = targetDiv[0].offsetHeight + 'px';

                    // Same 2-step toggle as jonak-paris2: add "appa" a beat later so the
                    // "bottom: -100%" state is committed first and the slide-up actually animates.
                    setTimeout(function () {
                        targetDiv.addClass("appa");
                    }, 100);
                }
            } else {
                if (targetDiv.hasClass("scrolling-active")) {
                    // Remove both classes together (no transition delay) so it snaps back instantly.
                    targetDiv.removeClass("scrolling-active appa");
                    document.body.style.paddingBottom = '';
                }
                // Layout may have shifted (images loaded, etc.) now that the block is back to normal flow
                computeTriggerScrollY();
            }
        }

        // Debounce scroll handler
        let scrollTimeout;
        const debouncedScroll = function() {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(handle_sticky_block, 10);
        };

        document.addEventListener('scroll', debouncedScroll, { passive: true });
        window.addEventListener('resize', function () {
            computeTriggerScrollY();
            handle_sticky_block();
        });

        const observer = new ResizeObserver(() => {
            handle_sticky_block();
        });
        observer.observe(document.body);

        // Initial check
        handle_sticky_block();

    }, isInit ? 1000 : 0);
}

/**
 * Generic cross-sell carousels initializer.
 * Scans every `.cross-sell-carousel_wrap` on the page (FP + other pages) and
 * initializes the inner Swiper on viewport enter. Same selector logic as mobile
 * (`override.js`) so behavior stays symmetrical between desktop and mobile.
 */
function initCrossSellCarousels() {
    function isElementInViewport(el) {
        if (!el || typeof el.getBoundingClientRect !== 'function') {
            return false;
        }

        var rect = el.getBoundingClientRect();
        var viewHeight = window.innerHeight || document.documentElement.clientHeight;
        var viewWidth = window.innerWidth || document.documentElement.clientWidth;

        return rect.bottom > 0 && rect.right > 0 && rect.top < viewHeight && rect.left < viewWidth;
    }

    function isCarouselInitialized($carousel) {
        return !!($carousel[0] && $carousel[0].swiper) || $carousel.hasClass('swiper-initialized');
    }

    function initCarouselIfNeeded($carousel) {
        if (isCarouselInitialized($carousel)) {
            return true;
        }

        // Resolve wrapper once: same anchor as mobile.
        var $wrap = $carousel.closest('.cross-sell-carousel_wrap');

        // Number of visible slides:
        // 1) per-carousel data-limit
        // 2) wrapper data-limit
        // 3) parent cross-sell data-limit (legacy)
        // 4) safe fallback = 4
        var displaySwiper = Number($carousel.data('limit'))
            || Number($wrap.data('limit'))
            || Number($carousel.closest('.cross-sell').data('limit'))
            || 4;

        // Business rule: in associated products, we keep arrows but no progressbar.
        var isAssociatedProducts = $carousel.closest('#associated_products, .associated_products').length > 0;

        // Controls are direct children of the wrapper (avoids collisions with nested swipers).
        var $controls = $wrap.find('> .cross-sell-controls').first();
        var paginationEl = $controls.find('.swiper-pagination')[0];
        var nextEl = $controls.find('.swiper-button-next')[0];
        var prevEl = $controls.find('.swiper-button-prev')[0];

        // Base Swiper config shared by all cross-sell carousels.
        // watchOverflow locks the swiper (hiding controls via CSS :has(.swiper-pagination-lock))
        // when there aren't enough slides — no need to shrink slidesPerView manually.
        // Responsive: on smaller viewports, decrement slidesPerView so tiles don't get oversized.
        var spvSmall = Math.max(1, displaySwiper - 2);
        var spvMedium = Math.max(1, displaySwiper - 1);

        var swiperConfig = {
            slidesPerView: spvSmall,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            // Auto-hide nav & pagination (per breakpoint) when all slides fit.
            watchOverflow: true,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },
            breakpoints: {
                1280: { slidesPerView: spvMedium },
                1600: { slidesPerView: displaySwiper },
            },
        };

        // Enable progressbar only where we want it.
        // In associated products, hide the pagination element to avoid empty UI.
        if (!isAssociatedProducts && paginationEl) {
            swiperConfig.pagination = {
                el: paginationEl,
                type: 'progressbar',
            };
        } else if (paginationEl) {
            $(paginationEl).hide();
        }

        new Swiper($carousel[0], swiperConfig);
        return true;
    }

    // Generic selector: any cross-sell carousel wrapped in `.cross-sell-carousel_wrap`
    // (FP, listing, cart, etc.). Non-carousel cross-sells (limited/all) are ignored by design.
    var target = $('.cross-sell-carousel_wrap .cross-sell-carousel.swiper-container');

    // Nothing to initialize on this page.
    if (!target.length) {
        return;
    }

    if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries, io) {
            entries.forEach(function(entry) {
                if (!entry.isIntersecting) {
                    return;
                }

                var $carousel = $(entry.target);
                initCarouselIfNeeded($carousel);
                io.unobserve(entry.target);
            });
        }, {
            threshold: 0.1,
            rootMargin: '120px 0px',
        });

        target.each(function() {
            var $carousel = $(this);

            if (isCarouselInitialized($carousel)) {
                return;
            }

            if (isElementInViewport(this)) {
                initCarouselIfNeeded($carousel);
                return;
            }

            observer.observe(this);
        });

        return;
    }

    // Fallback for browsers without IntersectionObserver.
    target.each(function() {
        var $carousel = $(this);

        if (isCarouselInitialized($carousel)) {
            return;
        }

        if (isElementInViewport(this)) {
            initCarouselIfNeeded($carousel);
        }
    });
}

/**
 * FP wrapper kept for retro-compatibility with existing call sites
 * (color change, product reload, ajax updates). Delegates to the generic initializer.
 */
function initFpCrossSell() {
    initCrossSellCarousels();
}

// Global init: run on every page EXCEPT FP (product page).
// FP is handled by `initFpCrossSell()` inside the product ready block above.
$(function () {
    if ($('body').hasClass('product_page')) {
        return;
    }
    if ($('.cross-sell-carousel_wrap').length) {
        initCrossSellCarousels();
    }
});